<div class="container-fluid ">
  <div class="row m-t-md pl-2">
    <div class="col-12 btn-group">
      <input type="text" class="p-inputtext" [(ngModel)]="userFilter"
        placeholder="{{ 'General.search.maxLength' | translate:{maxLength: this.MIN_SEARCH_TEXT_LENGHT} }}"
        name="filterText" id="filterTextInput" autocomplete="off" #searchField />
      <button class="btn btn-primary" type="button" aria-expanded="false"
        title="{{ 'Documents.reset.filters' | translate}}" (click)="clearFilter()">
        <i class="fas fa-trash" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="row m-t-sm">
    <div class="col-12">
      <p-scrollPanel [style]="{width: '100%', height: '90vh'}">
        <p-panelMenu [model]="menuItems"></p-panelMenu>
      </p-scrollPanel>
    </div>
  </div>
</div>